<template>
  <div class="container-fluid mt-4" dir="rtl">
    
    <!-- 1. لوحة التحكم والبحث -->
    <div class="card shadow-sm mb-4 border-top-primary no-print">
      <div class="card-header bg-white py-3 d-flex justify-content-between align-items-center">
        <h5 class="mb-0 text-primary fw-bold">
          <i class="fas fa-list-alt ms-2"></i> طباعة كشوف المناداة (مقسمة)
        </h5>
        <!-- التحكم في عدد الصفوف -->
        <div class="input-group input-group-sm w-auto">
            <span class="input-group-text bg-light">عدد الصفوف</span>
            <input type="number" v-model.number="rowsPerPage" class="form-control text-center fw-bold" style="width: 60px;">
        </div>
      </div>
      
      <div class="card-body">
        <div class="row g-3 align-items-end">
          
          <!-- فلتر الترم -->
          <div class="col-md-3">
            <label class="form-label fw-bold">الفصل الدراسي</label>
            <select v-model="form.term_id" class="form-select">
              <option value="">-- اختر --</option>
              <option v-for="t in terms" :key="t.id" :value="t">{{ t.name }}</option>
            </select>
          </div>

          <!-- فلتر الإدارة (لتقليل القائمة) -->
          <div class="col-md-3">
            <label class="form-label fw-bold">الإدارة التعليمية</label>
            <select v-model="form.admin_id" @change="fetchCommittees" class="form-select">
              <option value="">-- كل الإدارات --</option>
              <option v-for="admin in administrations" :key="admin.id" :value="admin.id">{{ admin.dep_name }}</option>
            </select>
          </div>

          <!-- فلتر اللجنة -->
          <div class="col-md-4">
            <label class="form-label fw-bold">اختر اللجنة (أو الكل)</label>
            <select v-model="form.committee_id" class="form-select" :disabled="loadingCommittees">
              <option value="">-- طباعة جميع اللجان (تقرير مجمع) --</option>
              <option v-for="c in committees" :key="c.id" :value="c.id">
                {{ c.committee_number }} - {{ c.commitee_name }} ({{ c.students_count }} طالب)
              </option>
            </select>
          </div>

          <div class="col-md-2">
            <button @click="fetchReport" class="btn btn-primary w-100 fw-bold shadow-sm" :disabled="loading || !form.term_id">
              <span v-if="loading" class="spinner-border spinner-border-sm ms-1"></span>
              <span v-else>عرض</span>
            </button>
          </div>
        </div>
        
        <div class="mt-3 text-end pt-3 border-top" v-if="processedReportData.length > 0">
           <button @click="printReport" class="btn btn-dark px-5 fw-bold">
             <i class="fas fa-print ms-2"></i> طباعة الكشوف
           </button>
        </div>
      </div>
    </div>

    <!-- 2. منطقة الطباعة (الديناميكية) -->
    <div id="printMe" v-if="processedReportData.length > 0">
      
      <!-- الحلقة الكبيرة: اللجان (في حالة اختيار الكل) -->
      <div v-for="(committeeData, cIdx) in processedReportData" :key="'comm-'+cIdx" class="committee-block " style=" page-break-after: always;" >
          
          <!-- الحلقة الوسطى: المدارس داخل اللجنة -->
          <div v-for="(school, sIdx) in committeeData.schools" :key="'sch-'+sIdx" style=" page-break-after: always;">
            
            <!-- الحلقة الصغرى: الصفحات (Pagination) -->
            <div 
              v-for="(page, pIdx) in school.pages" 
              :key="'page-'+pIdx" 
              class="print-page-wrapper"
            >
              
              <!-- === الجدول === -->
              <table class="table table-bordered border-dark text-center align-middle w-100 mb-0 page-table">
                
                <!-- الترويسة (داخل thead للتكرار) -->


              



                <thead>
                  <tr class="header-row border-0">
                    <th colspan="4" class="border-0 p-0">
                      <div class="report-header mb-2 pt-2">
                        <div class="row text-center align-items-center mb-2">
                          <div class="col-4 text-start">
                               <h6 class="fw-bold mb-1 fs-18">محافظة شمال سيناء</h6>
                        <h6 class="fw-bold mb-1 fs-18">مديرية التربية والتعليم</h6>
                        <h6 class="fw-bold mb-0 fs-18">لجنة النظام والمراقبة</h6>
                          </div>
                          <div class="col-4">
                            <h3 class="fw-bold text-decoration-underline m-0 fs-4">كشف مناداة</h3>
                         <h4 class="fw-bold text-decoration-underline m-0 fs-4">  {{ form.term_id['name'] }} </h4> 
                              <div class="badge bg-white text-dark border border-dark p-2 fs-6">
                           {{ form.term_id['years'] }}
                            </div>
                            
                         
                          </div>

                          <div class="col-4 text-start">
                        <div class="border border-dark p-2 rounded text-center bg-light">
                          <p class="mb-1 fw-bold text-dark fs-18">مقر اللجنة: {{ committeeData.commitee_name }}</p>
                          <p class="mb-0 fw-bold border-top border-secondary pt-1">
                             رقم اللجنة: ( {{ committeeData.id }} )
                          </p>
                        </div>
                      </div>

                        
                        </div>

                        <!-- اسم المدرسة -->
                        <div class="school-bar bg-dark text-white p-1 text-center border border-dark">
                           <h5 class="m-0 fw-bold fs-5">
                             {{ school.school_name }}
                             <span class="float-end fw-light fs-6 opacity-75 ms-2 pt-1">كود: {{ school.id }}</span>
                           </h5>
                        </div>
                      </div>
                    </th>
                  </tr>

                  <!-- عناوين الأعمدة -->
                  <tr class="bg-light fh-20">
                    <th width="15%" class="fs-5 border-2 border-dark">جلوس</th>
                    <th width="45%" class="fs-5 border-2 border-dark">الاسم</th>
                    <th width="15%" class="fs-5 border-2 border-dark">الديانة</th>
                    <th width="25%" class="fs-5 border-2 border-dark">ملاحظات</th>
                  </tr>
                </thead>

                <!-- جسم الجدول -->
                <tbody>
                  <tr v-for="student in page.students" :key="student.id">
                    <td class="fw-bold fs-4 font-monospace">{{ student.Seating_No }}</td>
                    <td class="text-start pe-3 fw-bold fs-25">{{ student.Arabic_Name }}</td>
                    <td class="fs-18">{{ student.Moslem_Name }}</td>
                    <td class="text-start px-2 fs-5 fw-bold ">

                      <div v-if="student.Damg_Status_id" class="d-inline-block small fw-bold border border-dark px-1 ms-1 rounded fs-20" style="margin-top: 7px; background-color: gray; color: white;">دمج : {{student.disability_type}}</div>
                        <div v-if="student.Stud_Type_Id == 2" class="d-inline-block small fw-bold border border-dark px-1 ms-1 rounded fs-20">منازل</div>
                      <!-- {{ getStudentStatus(student) }} -->
                    </td>
                  </tr>
                  
                  <!-- ملء الفراغ للحفاظ على ارتفاع الصفحة -->
                  <tr v-for="n in (rowsPerPage - page.students.length)" :key="'empty-'+n" class="empty-row">
                      <td colspan="4">&nbsp;</td>
                  </tr>
                </tbody>

                <!-- التذييل (داخل الجدول لضمان الالتصاق) -->
                <tfoot>
                    <tr class="footer-row border-0">
                        <td colspan="4" class="border-0 p-0">
                             <div class="page-footer mt-2 border-top border-2 border-dark pt-1">
                                 <div class="row align-items-center">
                                     <!-- الإحصاء (يظهر في آخر صفحة للمدرسة فقط) -->
                                     <div class="col-8 text-end">
                                         <div v-if="pIdx === school.pages.length - 1" class="stats-box border border-dark px-2 py-1 d-inline-block fw-bold small bg-light">
                                            إجمالي: {{ school.stats.total }} | 
                                            مسلم: {{ school.stats.muslim }} | 
                                            مسيحي: {{ school.stats.christian }} | 
                                            دمج: {{ school.stats.damg }}
                                         </div>
                                     </div>
                                     <!-- رقم الصفحة -->
                                     <div class="col-4 text-start">
                                         <span class="font-monospace small fw-bold">
                                             ( {{ pIdx + 1 }} / {{ school.pages.length }} )
                                         </span>
                                     </div>
                                 </div>
                             </div>
                        </td>
                    </tr>
                </tfoot>

              </table>

              <!-- فاصل صفحة -->
              <div class="page-break"></div>

            </div>
          </div>
      </div>

    </div>
  </div>
</template>

<script>
import api from '@/api/axios';
import _ from 'lodash'; // للتقسيم

export default {
  name: "CallingSheetPaged",
  data() {
    return {
      loading: false,
      loadingCommittees: false,
      
      terms: [],
      administrations: [], // قائمة الإدارات
      committees: [],      // قائمة اللجان (تتحدث بناءً على الإدارة)
      
      processedReportData: [], // البيانات النهائية المعالجة
      rowsPerPage: 25, // الافتراضي
      
      form: {
        term_id: "",
        admin_id: "", // فلتر جديد
        committee_id: "" // إذا كان فارغاً = هات الكل
      }
    };
  },
  mounted() {
    this.fetchInitData();
  },
  methods: {
    async fetchInitData() {
        try {
            const [tRes, aRes] = await Promise.all([
                api.get('/getterms'),
                api.get('getadmins') // API الإدارات
            ]);
            this.terms = tRes.data;
            this.administrations = aRes.data;
            
            // جلب كل اللجان مبدئياً
            this.fetchCommittees();
        } catch(e) { console.error(e); }
    },

    async fetchCommittees() {
        this.loadingCommittees = true;
        try {
            const res = await api.get('/admin/getCommittee', { 
                params: { admin_id: this.form.admin_id } 
            });
            this.committees = res.data;
        } finally {
            this.loadingCommittees = false;
        }
    },

    async fetchReport() {
      this.loading = true;
      this.processedReportData = [];

      try {
        // نرسل الطلب للباك إند (سواء لجنة واحدة أو الكل)
        const res = await api.post('/admin/calling-sheet-report', this.form);
        const rawData = res.data; // مصفوفة لجان

        // معالجة البيانات وتقسيمها
        this.processDataPagination(rawData);

      } catch (e) {
        console.error(e);
        alert("حدث خطأ أثناء جلب البيانات");
      } finally {
        this.loading = false;
      }
    },

    processDataPagination(committeesList) {
        // نمر على كل لجنة
        this.processedReportData = committeesList.map(committee => {
            
            // نمر على كل مدرسة داخل اللجنة
            const processedSchools = committee.schools.map(school => {
                // تقسيم طلاب المدرسة إلى صفحات
                const pages = _.chunk(school.students, this.rowsPerPage).map(chunk => ({
                    students: chunk
                }));

                return { ...school, pages };
            });

            return { ...committee, schools: processedSchools };
        });
    },

    getStudentStatus(student) {
        if(student.Damg_Status_id) return 'طالب دمج';
        if(student.Stud_Type_Id == 2) return 'منازل';
        if(student.Nationality == 2) return 'وافد';
        return '';
    },
    
    getTermName() {
        const t = this.terms.find(x => x.id === this.form.term_id);
        return t ? t.name : '';
    },

    printReport() {
      this.$htmlToPaper("printMe");
    }
  }
};
</script>

<style scoped>
.border-top-primary { border-top: 4px solid #0d6efd; }
.font-monospace { font-family: 'Courier New', monospace; }

/* تنسيقات الطباعة */
@media print {
  @page {
    size: A4 portrait;
    margin: 10mm;
  }

  body * { visibility: hidden; }
  .no-print { display: none !important; }
  #printMe, #printMe * { visibility: visible; }
  #printMe { position: absolute; left: 0; top: 0; width: 100%; }

  .page-break {
    page-break-after: always;
    height: 0;
    display: block;
    clear: both;
  }

  /* جدول */
  .table-bordered th, .table-bordered td {
      border: 1px solid #000 !important;
      font-size: 13pt !important;
      padding: 3px !important;
      height: 35px; /* ارتفاع ثابت لضمان التقسيم الصحيح */
  }

  /* إخفاء حدود الرأس والذيل */
  .header-row td, .footer-row td { border: none !important; }

  .bg-dark { background-color: #000 !important; color: #fff !important; -webkit-print-color-adjust: exact; }
  .bg-light { background-color: #f0f0f0 !important; -webkit-print-color-adjust: exact; }
  
  .empty-row td { color: transparent; border-bottom: 1px solid #000; }
}
</style>